import React from 'react';

import { Icon } from '../../icon';
import { IconProps } from '../../icon/types';

export const ArrowLittleRightIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.29079 17.2458C9.10454 17.0584 9 16.805 9 16.5408C9 16.2766 9.10454 16.0232 9.29079 15.8358L12.8308 12.2458L9.29079 8.7058C9.10454 8.51844 9 8.26498 9 8.0008C9 7.73661 9.10454 7.48316 9.29079 7.2958C9.38376 7.20207 9.49436 7.12768 9.61622 7.07691C9.73807 7.02614 9.86878 7 10.0008 7C10.1328 7 10.2635 7.02614 10.3854 7.07691C10.5072 7.12768 10.6178 7.20207 10.7108 7.2958L14.9508 11.5358C15.0445 11.6288 15.1189 11.7394 15.1697 11.8612C15.2205 11.9831 15.2466 12.1138 15.2466 12.2458C15.2466 12.3778 15.2205 12.5085 15.1697 12.6304C15.1189 12.7522 15.0445 12.8628 14.9508 12.9558L10.7108 17.2458C10.6178 17.3395 10.5072 17.4139 10.3854 17.4647C10.2635 17.5155 10.1328 17.5416 10.0008 17.5416C9.86878 17.5416 9.73808 17.5155 9.61622 17.4647C9.49436 17.4139 9.38376 17.3395 9.29079 17.2458Z"
      fill="currentColor"
    />
  </Icon>
);
